import React from 'react';

import { jitsiLocalStorage } from 'lib-js-utils';

import { translate } from '../../../../base/i18n';
import { connect } from '../../../../base/redux';
import { DialogKnowhow, DialogMiruna } from '../../../../base/dialog';

const DemoAlertDialog = (props) => {
    const state = APP.store.getState();
    const localDemoUser = jitsiLocalStorage.getItem('localDemoUser');
    console.log('XXX alert state', localDemoUser)
   // console.log('XXX local part: ',this.state.localParticipant)

    if (localDemoUser === "miruna.caramangiu@gmail.com") {
        return (
            <DialogMiruna
                isForm={false}
                hideCancelButton={false}
                submitDisabled={false}
                width={'small'}
            >
                <div className={'alert-modal'} >
                    <h3>Incoming Cellular Calls . . .</h3>
                </div>
            </DialogMiruna>
        )
    }
    if (localDemoUser === "knowhow@innovationsapplied.com") {
        return (
            <DialogKnowhow
                isForm={false}
                hideCancelButton={false}
                submitDisabled={false}
                width={'small'}
            >
                <div className={'alert-modal'} >
                    <h3>Incoming Cellular Calls . . .</h3>
                </div>
            </DialogKnowhow>
        )
    }
}


function mapStateToProps(state, ownProps) {
    const invite = state['features/invite'];
    return {
        alertState: invite.alertState
    }
}

const mapDispatchToProps = {

}

export default translate(
    connect(mapStateToProps, mapDispatchToProps)(translate(DemoAlertDialog))
);